import { render } from "./UnderDev.vue?vue&type=template&id=79a7123b&scoped=true"
import script from "./UnderDev.vue?vue&type=script&lang=js"
export * from "./UnderDev.vue?vue&type=script&lang=js"

import "./UnderDev.vue?vue&type=style&index=0&id=79a7123b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a7123b"]])

export default __exports__